import { api } from './client';
import type { Match, MatchPhase, MatchStatus, Team, TeamHistory } from './types';

export const matchesApi = {
  list: (filters?: { phase?: MatchPhase; group?: string }) => {
    const params = new URLSearchParams();
    if (filters?.phase) params.set('phase', filters.phase);
    if (filters?.group) params.set('group', filters.group);
    const qs = params.toString();
    return api.get<Match[]>('/matches' + (qs ? `?${qs}` : ''));
  },
  detail: (id: string) => api.get<Match>(`/matches/${id}`),
  // Finished tournament matches of both teams of this match — context for an upcoming match.
  teamHistory: (id: string) => api.get<TeamHistory>(`/matches/${id}/team-history`),

  // Admin
  teams: () => api.get<Team[]>('/admin/teams'),
  saveTeam: (req: { code: string; name: string; color?: string }) =>
    api.post<Team>('/admin/teams', req),
  create: (req: AdminMatchInput) => api.post<Match>('/admin/matches', req),
  update: (id: string, req: AdminMatchInput) => api.put<Match>(`/admin/matches/${id}`, req),
  delete: (id: string) => api.delete<void>(`/admin/matches/${id}`),
};

export interface AdminMatchInput {
  phase: MatchPhase;
  group?: string | null;
  homeTeam: string;
  awayTeam: string;
  homePlaceholder?: string | null;
  awayPlaceholder?: string | null;
  kickoff: string; // ISO
  venue?: string | null;
  status?: MatchStatus;
  homeScore?: number | null;
  awayScore?: number | null;
  externalMatchId?: number | null;
}
